var CloseReasons = /* @__PURE__ */ ((CloseReasons2) => (CloseReasons2.APPLY = "apply", CloseReasons2.CANCEL = "cancel", CloseReasons2))(CloseReasons || {});
export {
  CloseReasons
};
//# sourceMappingURL=enums.js.map
